/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Self_Organize_Count_HintInputs */



/**
* | output |
* | --- |
* | "{count} players in this pod (4 or 5 required)." |
*
* @param {Self_Organize_Count_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const self_organize_count_hint = /** @type {((inputs: Self_Organize_Count_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Self_Organize_Count_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} joueurs dans ce groupe (4 ou 5 requis).`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} jugadores en este grupo (se requieren 4 o 5).`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} jogadores neste grupo (4 ou 5 obrigatório).`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} giocatori in questo gruppo (4 o 5 richiesti).`)
	return /** @type {LocalizedString} */ (`${i?.count} players in this pod (4 or 5 required).`)
});